import cn from 'classnames';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import NoAccessOverlay from '@/creditflowresearch/ui/common/components/NoAccessOverlay';
import MissingSomethingModalButton from '@/creditflowresearch/ui/common/components/MissingSomethingModalButton';
import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import PageHeaderWrapper from '@/creditflowresearch/ui/common/components/PageHeaderWrapper';
import image from '@/openMarket/ui/assets/noAccess/openMarketNoAccess.webp';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';

import {
  OPEN_MARKET_PAGE_TITLE,
  openMarketNoAccessDescription,
  openMarketNoAccessFeatures,
  openMarketImageCaption,
} from './constants';

import headerWrapperStyles from '@/creditflowresearch/ui/common/components/PageHeaderWrapper/pageHeaderWrapper.module.scss';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';

const RequiredUserPlan = () => {
  const { checkAccessByUserPlan } = useUserPlanContext();

  return (
    <PageContentLayout>
      <PageHeaderWrapper
        title="OpenMarket Profiles"
        className={ headerWrapperStyles.pageHeaderNoWrap }
        userAccessChecks={ [checkAccessByUserPlan(UserPlanType.STARTER)] }
      />
      <CheckUserAccess
        conditions={ [{
          checks: [checkAccessByUserPlan(UserPlanType.STARTER)],
          fallback: (
            <NoAccessOverlay
              title={ OPEN_MARKET_PAGE_TITLE }
              description={ openMarketNoAccessDescription }
              features={ openMarketNoAccessFeatures }
              imageCaption={ openMarketImageCaption }
              image={ image.src }
              isLoginButton
            />
          ),
        }] }
      />
      <MissingSomethingModalButton className={ cn(spacesStyles.ptxl, spacesStyles.pbxl) } />
    </PageContentLayout>
  );
};

export default RequiredUserPlan;
